var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49833 20C3.55344 20 0.355469 16.802 0.355469 12.8571C0.355469 11.4539 1.08793 9.53719 2.38641 7.07763C2.69861 6.48628 3.0398 5.87294 3.40548 5.24256C4.04361 4.14252 4.72554 3.04228 5.40739 1.9924C5.64606 1.62491 5.86788 1.28965 6.06731 0.993059C6.18793 0.813688 6.27498 0.686057 6.32292 0.616658C6.89086 -0.205552 8.1058 -0.205552 8.67373 0.616658C8.72167 0.686057 8.80873 0.813688 8.92934 0.993059C9.12877 1.28965 9.3506 1.62491 9.58926 1.9924C10.2711 3.04228 10.953 4.14252 11.5912 5.24256C11.9568 5.87294 12.298 6.48628 12.6102 7.07763C13.9087 9.53719 14.6412 11.4539 14.6412 12.8571C14.6412 16.802 11.4432 20 7.49833 20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/drop.874ac2de.svg";
export { ForwardRef as ReactComponent };